import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Stepper from "../../components/steper/Stepper";
import { fetchPincodeDeatails } from "../../redux/slices/pincodeSlice";
import "./companypage.css";
import { MapPinPlus } from "lucide-react";

const Company = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dropdownRef = useRef();
  const { data: pincodeResults } = useSelector((state) => state.pincode);
   const [errors, setErrors] = useState({});
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const generateUsername = () => {
    const now = new Date();
    const timestamp = now.getTime();
    return `RKIT${timestamp}`;
  };

  const [formData, setFormData] = useState({
    firm_name: "",
    member_business_type: "",
    username: generateUsername(),
    password: "12345678",
    member_firm_address: "",
    member_city: "",
    member_type: 2,
    member_state: "",
    member_pin: "",
  });

 

  useEffect(() => {
    const userDataString = localStorage.getItem("user");
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        if (userData.member_active === 0) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            firm_name: userData.member_firm_name || "",
            member_business_type: userData.member_business_type || "",
            member_firm_address: userData.member_firm_address || "",
            member_city: userData.member_city || "",
            member_state: userData.member_state || "",
            member_pin: userData.member_pin || "",
          }));
        }
      } catch (error) {
        console.error("Error parsing userData from localStorage:", error);
      }
    }
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "member_pin") {
      // Allow only numbers (0-9)
      const numericValue = value.replace(/\D/g, "");
      setFormData({ ...formData, [name]: numericValue });

      // Clear error if user corrects it
      if (errors[name]) {
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      }

      // Fetch pincode details if length is 6
      if (numericValue.length === 6) {
        dispatch(fetchPincodeDeatails(numericValue));
        setDropdownVisible(true);
      } else {
        setDropdownVisible(false);
      }

      return;
    }

    setFormData({ ...formData, [name]: value });

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.firm_name) newErrors.firm_name = "Company Name is required";
    if (!formData.member_business_type)
      newErrors.member_business_type = "Business Type is required";
    if (!formData.member_firm_address)
      newErrors.member_firm_address = "Street Address is required";
    if (!formData.member_city) newErrors.member_city = "City is required";
    if (!formData.member_state) newErrors.member_state = "State is required";

    if (!formData.member_pin) {
      newErrors.member_pin = "Pincode is required";
    } else if (formData.member_pin.length !== 6) {
      newErrors.member_pin = "Pincode must be exactly 6 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleProceed = () => {
    if (validateForm()) {
      console.log("form----data--", formData);
      localStorage.setItem("companyStep1", JSON.stringify(formData));
      navigate("/companypagestep");
    }
  };

  const handleDropdownSelect = (office) => {
    setFormData({
      ...formData,
      member_firm_address: office.Name,
      member_city: office.District,
      member_state: office.State,
      member_pin: office.Pincode,
    });
    setDropdownVisible(false);
  };

  return (
    <>
      <div className="stepper_root">
        <Stepper currentStep={0} />
      </div>

      <div className="form-container">
        <form className="custom-form" autoComplete="off">
          <div className="form-group">
            <label>Company Name *</label>
            <input
              type="text"
              name="firm_name"
              value={formData.firm_name}
              onChange={handleChange}
              className={errors.firm_name ? "error-border" : ""}
            />
            {errors.firm_name && (
              <span className="error-text">{errors.firm_name}</span>
            )}
          </div>

          <div className="form-group">
            <label>Business Type *</label>
            <input
              type="text"
              name="member_business_type"
              value={formData.member_business_type}
              onChange={handleChange}
              className={errors.member_business_type ? "error-border" : ""}
            />
            {errors.member_business_type && (
              <span className="error-text">{errors.member_business_type}</span>
            )}
          </div>

          <div
            className="form-group"
            ref={dropdownRef}
            style={{ position: "relative" }}
          >
            <label>Pincode *</label>
            <input
              type="text"
              name="member_pin"
              value={formData.member_pin}
              onChange={handleChange}
              autoComplete="off"
              maxLength="6"
              className={errors.member_pin ? "error-border" : ""}
            />
            {errors.member_pin && (
              <span className="error-text">{errors.member_pin}</span>
            )}
            {dropdownVisible && pincodeResults?.length > 0 && (
              <div className="dropdown">
                {pincodeResults.map((office, index) => (
                  <div
                    key={index}
                    className="dropdown-item"
                    onClick={() => handleDropdownSelect(office)}
                  >
                    <span>
                      <MapPinPlus color="#007bff" />
                    </span>
                    &nbsp;
                    {office.Name}, {office.Block}, {office.District},{" "}
                    {office.Country}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="form-group">
            <label>Street Address *</label>
            <input
              type="text"
              name="member_firm_address"
              value={formData.member_firm_address}
              onChange={handleChange}
              className={errors.member_firm_address ? "error-border" : ""}
            />
            {errors.member_firm_address && (
              <span className="error-text">{errors.member_firm_address}</span>
            )}
          </div>

          <div className="form-group">
            <label>City *</label>
            <input
              type="text"
              name="member_city"
              value={formData.member_city}
              onChange={handleChange}
              className={errors.member_city ? "error-border" : ""}
            />
            {errors.member_city && (
              <span className="error-text">{errors.member_city}</span>
            )}
          </div>

          <div className="form-group">
            <label>State *</label>
            <input
              type="text"
              name="member_state"
              value={formData.member_state}
              onChange={handleChange}
              className={errors.member_state ? "error-border" : ""}
            />
            {errors.member_state && (
              <span className="error-text">{errors.member_state}</span>
            )}
          </div>

          <div className="root_btn_proces">
            <button
              type="button"
              className="submit-btn"
              onClick={handleProceed}
            >
              Proceed
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Company;
